export default __webpack_public_path__ + "static/media/flight-ico.38007934.svg";